import React from "react";
import { useEffect } from "react";
import BlogsComp from "../components/Blogs/BlogsComp";
import Location from "../components/Location/Location";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const About = () => {
  const navigate = useNavigate();
  const theme = useSelector((state) => state.theme.theme); // Get the theme state

  const handleNavigate = () => {
    navigate("/");
  };
  useEffect(() => {
    // Scroll to top when the component mounts
    window.scrollTo(0, 0);
  }, []);

  const isDarkTheme = theme === "dark";

  return (
    <>
      <div
        className={`container mx-auto ${
          isDarkTheme ? "text-white bg-black" : "text-black bg-white"
        } pt-14`}
      >
        <div className="py-10 px-6 md:px-12 lg:px-20">
          {/* Heading Section */}
          <h1
            className={`relative md:text-5xl text-3xl font-extrabold mb-6 border-l-8 pl-4 ${
              isDarkTheme
                ? "text-[#5b53fb] border-[#5b53fb]"
                : "text-[#5b53fb] border-[#5b53fb]"
            }`}
          >
            <span className="z-10 flex md:justify-center justify-start bg-clip-text text-transparent bg-gradient-to-r from-[#5b53fb] to-[#5b53fb]">
              About TripDekhoo
            </span>
          </h1>
          <p
            className={`text-xl leading-relaxed animate-fade-in ${
              isDarkTheme ? "text-gray-300" : "text-gray-700"
            }`}
          >
            At{" "}
            <span
              className={`font-bold ${
                isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
              }`}
            >
              TripDekhoo.com
            </span>
            , we believe travel is more than just visiting destinations—it's
            about creating moments that take your breath away. With us, every
            journey transforms into an unforgettable story. From sun-kissed
            beaches to towering mountain peaks, we turn your travel dreams into
            reality.
          </p>
          <br />
          <p
            className={`text-xl leading-relaxed animate-fade-in delay-200 ${
              isDarkTheme ? "text-gray-300" : "text-gray-700"
            }`}
          >
            Driven by a team of passionate travel enthusiasts,{" "}
            <span
              className={`font-semibold ${
                isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
              }`}
            >
              TripDekhoo
            </span>{" "}
            brings the world to your fingertips. Discover expertly curated
            itineraries, explore hidden gems, and enjoy seamless experiences—all
            tailored specifically for you.
          </p>

          {/* Why Choose Us Section */}
          <div className="mt-14">
            <h2
              className={`text-4xl font-bold mb-6 ${
                isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
              }`}
            >
              Why Choose TripDekhoo?
            </h2>
            <ul
              className={`space-y-6 text-lg animate-slide-up ${
                isDarkTheme ? "text-gray-300" : "text-gray-700"
              }`}
            >
              <li className="flex items-start">
                <span
                  className={`text-2xl mr-3 ${
                    isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  🌍
                </span>
                <span>
                  <strong>Personalized Journeys</strong> – Every traveler is
                  unique, and we ensure your adventure is a reflection of your
                  personal style and preferences.
                </span>
              </li>
              <li className="flex items-start">
                <span
                  className={`text-2xl mr-3 ${
                    isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  ✈️
                </span>
                <span>
                  <strong>Effortless Planning</strong> – Let us handle the
                  details. From flights to hotels and local guides, we take care
                  of everything, so you can focus on making memories.
                </span>
              </li>
              <li className="flex items-start">
                <span
                  className={`text-2xl mr-3 ${
                    isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  🏞️
                </span>
                <span>
                  <strong>Exclusive Destinations</strong> – Whether it's hidden
                  gems or world-famous landmarks, we offer a range of
                  destinations that cater to every kind of explorer.
                </span>
              </li>
              <li className="flex items-start">
                <span
                  className={`text-2xl mr-3 ${
                    isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                  }`}
                >
                  🤝
                </span>
                <span>
                  <strong>Reliable Service</strong> – Backed by years of
                  expertise and a community of satisfied travelers, TripDekhoo
                  is a name you can trust for your travel needs.
                </span>
              </li>
            </ul>
          </div>

          {/* Join Our Journey Section */}
          <div className="mt-16">
            <h2
              className={`text-4xl font-bold mb-6 ${
                isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
              }`}
            >
              Join Our Journey
            </h2>
            <p
              className={`text-xl leading-relaxed animate-fade-in ${
                isDarkTheme ? "text-gray-300" : "text-gray-700"
              }`}
            >
              At TripDekhoo, we don’t just offer trips—we create unforgettable
              experiences that redefine the way you travel. Whether you're
              looking for thrilling adventures, serene retreats, or immersive
              cultural escapes, we're your gateway to extraordinary
              destinations.
            </p>
            <br />
            <p
              className={`text-xl leading-relaxed animate-fade-in delay-200 ${
                isDarkTheme ? "text-gray-300" : "text-gray-700"
              }`}
            >
              Pack your bags and let’s embark on a journey of a lifetime. Your
              dream destination is just a click away with{" "}
              <span
                className={`font-bold ${
                  isDarkTheme ? "text-[#5b53fb]" : "text-[#5b53fb]"
                }`}
              >
                TripDekhoo.com
              </span>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div
        className={`py-16 px-6 md:px-12 lg:px-20 text-center ${
          isDarkTheme ? "bg-[#5b53fb] text-black" : "bg-[#5b53fb] text-white"
        }`}
      >
        <h2 className="text-4xl font-extrabold mb-4">
          Ready to Explore the World?
        </h2>
        <p className="text-xl leading-relaxed mb-8">
          Take the first step towards your dream vacation with TripDekhoo. Let’s
          make memories together!
        </p>
        <button
          onClick={handleNavigate}
          className={`px-6 py-3 font-bold rounded-lg transition duration-300 ${
            isDarkTheme
              ? "bg-indigo-300 text-white hover:bg-indigo-400 hover:text-black"
              : "bg-white text-[#5b53fb] hover:bg-indigo-300 hover:text-gray-100"
          }`}
        >
          Start Your Journey
        </button>
      </div>
    </>
  );
};

export default About;
